/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** CreateUsersResendUserWelcomeEmailRequest — dark-roast DTO: ResendUserWelcomeEmailDto */
export const createUsersResendUserWelcomeEmailRequestSchema = z.object({ "contactId": z.string().uuid().nullish() });
export type CreateUsersResendUserWelcomeEmailRequest = z.infer<typeof createUsersResendUserWelcomeEmailRequestSchema>;
